export default "__VITE_PUBLIC_ASSET__db1978e7__"